import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ASAP_TIME } from '../libs/polygon-ordering/src/constants';

const initialState: DeliveryAddressForm = {
  page: 'DeliveryTimeAndAddressSelection',
  modalHeight: 100,
  addressSuggestions: [],
  deliveryTime: ASAP_TIME,
  showTimePicker: false,
  submittingForm: false,
  addressSelectionView: 'Map',
  adjustingPin: false,
  resetMapCenter: false,
};

const slice = createSlice({
  name: 'deliveryAddressForm',
  initialState: initialState,
  reducers: {
    updateForm(state, action: PayloadAction<Partial<DeliveryAddressForm>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetForm(_state) {
      return initialState;
    },
    setSelectedAddress(state, action: PayloadAction<DeliveryAddress | undefined>) {
      if (!state.selectedAddress) {
        state.selectedAddress = action.payload;
        return state;
      }

      state.selectedAddress = {
        ...state.selectedAddress,
        ...action.payload,
      };

      if (!action.payload?.addressId) {
        delete state.selectedAddress.addressId;
      }

      return state;
    },
    // Could possibly have refactored one of the above reducers to achieve this but didn't want to break anything
    // This reducer will reset the selectedAddress to the initial value when the user discards changes on the confirmation page
    replaceSelectedAddress(state, action: PayloadAction<DeliveryAddress | undefined>) {
      state.selectedAddress = action.payload;
      return state;
    },
  },
});

export const { updateForm, resetForm, setSelectedAddress, replaceSelectedAddress } = slice.actions;

export default slice.reducer;
